import { JsonObject } from 'json2typescript';
import { CurrencyDataInterface } from '../interfaces/currency-data.interface';

@JsonObject('CurrencyDataModel')
export class CurrencyDataModel implements CurrencyDataInterface {
  symbol?: string;
  symbolPosition?: string;
  decimalSeparator?: string;
  groupSeparator?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
